<template>
  <section
    id="vibe-coding"
    class="te-vibe-coding bg-cover bg-center px-5 py-12 md:px-0 md:py-20"
  >
    <div class="co-container-sm flex flex-col gap-4 bg-white p-4 md:flex-row md:gap-8">
      <img
        src="~/assets/images/Te/TeCourse/Ordermade/VibeCoding/illust-vibecodeing-sp.svg"
        class="mx-auto md:hidden"
        width="280"
        height="212"
        loading="lazy"
      >
      <img
        src="~/assets/images/Te/TeCourse/Ordermade/VibeCoding/illust-vibecodeing-pc.svg"
        class="hidden md:block"
        width="300"
        height="355"
        loading="lazy"
      >
      <div>
        <div class="text-center md:text-left">
          <span class="mb-1 inline-block text-[1.25rem] font-bold text-[#5D60F2] md:text-[1.5rem]">オーダーメイドコース特典</span>
          <h2 class="mb-5 text-[1.5rem] font-bold leading-tight md:mb-6 md:text-[2.25rem]">
            VibeCodingが追加で学べる
          </h2>
        </div>
        <h3 class="co-display-11 mb-1 font-bold leading-base md:mb-2">
          AIと対話して開発する次世代のプログラミング手法
        </h3>
        <p class="mb-1 text-co-gray-600 md:mb-2">
          オーダーメイドコースでは、特典としてVibeCodingのカリキュラムをご用意しています。VibeCodingは、コードを直接書かず、AIとの対話でアプリケーション開発する次世代のプログラミング手法です。未経験の方でも安心して取り組め、AIとの対話を通じて開発の流れを自然に理解できます。さらに、VibeCodingで全体像をつかんだ後に実際のコーディングを学ぶことで、スキルの定着をより早めることができます。
        </p>
        <span class="text-[0.625rem] text-co-gray-600 md:text-[0.75rem]">※AIツールを10ドル（USD）分まで無料でご利用いただけます。</span>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-vibe-coding {
  background-image: url('~/assets/images/Te/TeCourse/Ordermade/VibeCoding/vibecodeing-bg.webp');
}
</style>
